import store from 'store';
import { kebabCase } from 'lodash';

const KEY = 'anchor';

export const anchorStorage = {
  get() {
    return store.get(KEY) || {};
  },

  set(state, value) {
    const { name } = state.router.currentState;
    const hash = kebabCase(value);
    store.set(KEY, { name, hash });
  },

  remove() {
    store.remove(KEY);
  },
};



// WEBPACK FOOTER //
// ./src/utils/anchorStorage.js